"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAuth = exports.useAmplifyUser = exports.setCustomPcAuthStorage = exports.getUserState = exports.federatedSignInGoogle = exports.default = exports.Context = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _Authentication = _interopRequireWildcard(require("./Authentication"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var loadAuth = function loadAuth() {
  return import(
  /* webpackChunkName: 'amplifyAuthPc' */
  '../auth/Pc').then(function (module) {
    return module.PcAuth;
  });
};

var Context = /*#__PURE__*/(0, _react.createContext)({});
exports.Context = Context;
var PcUserResource = (0, _Authentication.createAmplifyUserResource)(loadAuth).prepare();

var Pc = function Pc(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Authentication.default, (0, _extends2.default)({
    Context: Context,
    loadAuth: loadAuth,
    UserResource: PcUserResource,
    identifier: "pc"
  }, props));
};

var _default = Pc;
/**
 * Experimental suspender hook.
 * Improves Performance of UI by suspending components if amplify has not loaded the user yet.
 * Avoid rendering components multiple times when amplify state updates.
 *
 * @returns {AmplifyContextType} amplify context
 */

exports.default = _default;

var useAmplifyUser = function useAmplifyUser() {
  return (0, _react.useContext)(Context);
};

exports.useAmplifyUser = useAmplifyUser;

var withAuth = function withAuth(component) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Pc, {
    children: component
  });
};

exports.withAuth = withAuth;

var getUserState = function getUserState() {
  return (0, _Authentication.createFetchUserDataPromise)(loadAuth);
};

exports.getUserState = getUserState;

var setCustomPcAuthStorage = function setCustomPcAuthStorage(value) {
  return (0, _Authentication.setCustomAuthStorage)('pc', value);
};

exports.setCustomPcAuthStorage = setCustomPcAuthStorage;

var federatedSignInGoogle = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(customState) {
    var PcAuth;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (customState) {
              setCustomPcAuthStorage(customState);
            }

            _context.next = 3;
            return loadAuth();

          case 3:
            PcAuth = _context.sent;
            return _context.abrupt("return", PcAuth.federatedSignIn({
              provider: 'Google'
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function federatedSignInGoogle(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.federatedSignInGoogle = federatedSignInGoogle;